class Resources {

    constructor() {
        window.Nav.navOpacityChanger();
        $(document).ready(() => {
            return this.fixHeights();
        });

        $(window).on('load', () => {
            return this.fixHeights();
        });

        $(window).resize(() => {
            return this.fixHeights();
        });
    }

    fixHeights() {
        const $descriptions = $('.resource-description');

        let descH = 0;

        $descriptions.each((i, el) => {
            $(el).css({
                height: 'auto',
            });

            if ($(el).outerHeight() > descH) {
                return descH = $(el).outerHeight();
            }
        }).css({
            height: descH,
        });

        const $names = $('.resource-name-icon');

        descH = 0;

        return $names.each((i, el) => {
            $(el).css({
                height: 'auto',
            });

            if ($(el).outerHeight() > descH) {
                return descH = $(el).outerHeight();
            }
        }).css({
            height: descH,
        });
    }
}

export default Resources;
